<script>
  import QuestionCard from './QuestionCard.svelte'
  import { QUESTION_TYPES } from './survey_builder.svelte.js'

  // The survey's questions, one card each: the selected one open for editing, the rest summarised. Cards reorder by
  // dragging their handle (or with the up/down buttons). The questions are posted as the hidden nested form fields
  // the page's form submits.
  let { builder, fieldPrefix } = $props()

  let choosingType = $state(false)
  let list = $state(null)

  // A follow-up left without a question to depend on (it was removed, or none is picked) would save as asked of
  // everyone, so saving waits until it's fixed: the page's form doesn't submit, and the follow-up opens with its
  // problem.
  $effect(() => {
    const form = list?.closest('form')
    if (!form) return
    const check = event => {
      const broken = builder.questions.find(question => builder.conditionProblem(question))
      if (!broken) return
      event.preventDefault()
      builder.selectedUid = broken.uid
    }
    form.addEventListener('submit', check)
    return () => form.removeEventListener('submit', check)
  })
  let dragging = $state(null)
  let dropIndex = $state(null)

  const fields = $derived(builder.formFields(fieldPrefix))

  function add(type) {
    builder.add(type)
    choosingType = false
  }

  function dragOver(event, index) {
    if (!dragging) return
    event.preventDefault()
    const box = event.currentTarget.getBoundingClientRect()
    dropIndex = event.clientY > box.top + box.height / 2 ? index + 1 : index
  }

  function drop(event) {
    event.preventDefault()
    if (!dragging || dropIndex === null) return
    const from = builder.questions.indexOf(dragging)
    builder.move(dragging, dropIndex > from ? dropIndex - 1 : dropIndex)
    endDrag()
  }

  function endDrag() {
    dragging = null
    dropIndex = null
  }
</script>

<div class="space-y-3" role="list" bind:this={list} ondragover={event => dragging && event.preventDefault()} ondrop={drop}>
  {#each builder.questions as question, index (question.uid)}
    <div
      role="listitem"
      class="relative"
      ondragover={event => dragOver(event, index)}
    >
      {#if dragging && dropIndex === index}
        <div class="absolute -top-2 left-0 right-0 h-0.5 rounded bg-blue-500"></div>
      {/if}
      <QuestionCard
        {builder}
        {question}
        {index}
        dragging={dragging === question}
        onDragStart={() => (dragging = question)}
        onDragEnd={endDrag}
      />
      {#if dragging && dropIndex === index + 1 && index === builder.questions.length - 1}
        <div class="absolute -bottom-2 left-0 right-0 h-0.5 rounded bg-blue-500"></div>
      {/if}
    </div>
  {/each}

  {#if builder.questions.length === 0}
    <p class="text-sm text-gray-500">Add a question to start your survey.</p>
  {/if}

  {#if choosingType}
    <div class="field-box space-y-2">
      <div class="flex items-center justify-between">
        <span class="text-sm font-semibold text-gray-900">What kind of question?</span>
        <button type="button" class="text-sm text-gray-500 hover:text-gray-800" onclick={() => (choosingType = false)}>
          Cancel
        </button>
      </div>
      <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {#each QUESTION_TYPES as type (type.name)}
          <button
            type="button"
            class="rounded-xl border border-gray-200 bg-white px-4 py-3 text-left hover:border-blue-400 hover:bg-blue-50"
            onclick={() => add(type.name)}
          >
            <span class="block text-sm font-semibold text-gray-900">{type.label}</span>
            <span class="block text-xs text-gray-500">{type.hint}</span>
          </button>
        {/each}
      </div>
    </div>
  {:else}
    <button type="button" class="dashboard-btn-add-options flex justify-between" onclick={() => (choosingType = true)}>
      Add question
      <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0H5v5H0v2h5v5h2V7h5V5H7V0Z" fill="currentColor" />
      </svg>
    </button>
  {/if}
</div>

{#each fields as [name, value]}
  <input type="hidden" {name} value={value ?? ''} />
{/each}
